import { keyframes } from '@mui/material';
import type { Keyframes } from '@emotion/react';

export const conicRotate: Keyframes = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
